import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

// Todo - deprecate this store and put all state on server, as we are patching existing booking.
//  Invalid time window only introduces potential bugs when session storage is cleared,
// Metadata can just be replaced by having slug in all recalls paths
// comment can also be patched righted away.

interface BookingState {
  clearStore: () => void;

  bookingMetaData: { slug?: string; bookingId?: number };
  setBookingMetaData: (bookingMetaData: { slug: string; bookingId: number }) => void;

  comment?: string;
  setComment: (comment: string) => void;

  hasInvalidTimeWindow?: boolean;
  setHasInvalidTimeWindow: (hasInvalidTimeWindow: boolean) => void;
}

// Initial state with empty values
const initialStateValues = {
  bookingMetaData: { slug: undefined, bookingId: undefined },
  comment: '',
  hasInvalidTimeWindow: false
};

const useRecallStore = create<BookingState>()(
  persist(
    devtools((set) => ({
      ...initialStateValues,
      clearStore: () => set(initialStateValues),

      setBookingMetaData: (bookingMetaData) =>
        set({
          bookingMetaData
        }),

      setComment: (comment) => set({ comment }),

      setHasInvalidTimeWindow: (hasInvalidTimeWindow) => set({ hasInvalidTimeWindow })
    })),
    {
      name: 'recall',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

// Getters
export const useRecallComment = () => useRecallStore((state) => state.comment);
export const useRecallMetaData = () => useRecallStore((state) => state.bookingMetaData);
export const useRecallHasInvalidTimeWindow = () => useRecallStore((state) => state.hasInvalidTimeWindow);

// Actions
export const useRecallActions = () => {
  const clearStore = useRecallStore((state) => state.clearStore);
  const setComment = useRecallStore((state) => state.setComment);
  const setBookingMetaData = useRecallStore((state) => state.setBookingMetaData);
  const setHasInvalidTimeWindow = useRecallStore((state) => state.setHasInvalidTimeWindow);

  return {
    clearStore,
    setComment,
    setBookingMetaData,
    setHasInvalidTimeWindow
  };
};
